import { defineComponent as _defineComponent } from 'vue';
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
import MenuContent from './MenuContent.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    axis: {},
    el: {},
    menus: {},
    removeContextmenu: {
      type: Function
    }
  },
  setup(__props) {
    const props = __props;
    const style = computed(() => {
      const MENU_WIDTH = 170;
      const MENU_HEIGHT = 30;
      const DIVIDER_HEIGHT = 11;
      const PADDING = 5;
      const {
        x,
        y
      } = props.axis;
      const menuCount = props.menus.filter(menu => !(menu.divider || menu.hide)).length;
      const dividerCount = props.menus.filter(menu => menu.divider).length;
      const menuWidth = MENU_WIDTH;
      const menuHeight = menuCount * MENU_HEIGHT + dividerCount * DIVIDER_HEIGHT + PADDING * 2;
      const screenWidth = document.body.clientWidth;
      const screenHeight = document.body.clientHeight;
      return {
        left: screenWidth <= x + menuWidth ? x - menuWidth : x,
        top: screenHeight <= y + menuHeight ? y - menuHeight : y
      };
    });
    const handleClickMenuItem = item => {
      if (item.disable) return;
      if (item.children && !item.handler) return;
      if (item.handler) item.handler(props.el);
      props.removeContextmenu();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "mask",
        onContextmenu: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.removeContextmenu(), ["prevent"])),
        onMousedown: _cache[1] || (_cache[1] = $event => _ctx.removeContextmenu())
      }, null, 32), _createElementVNode("div", {
        class: "contextmenu",
        style: _normalizeStyle({
          left: style.value.left + 'px',
          top: style.value.top + 'px'
        }),
        onContextmenu: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, [_createVNode(MenuContent, {
        menus: _ctx.menus,
        handleClickMenuItem: handleClickMenuItem
      }, null, 8, ["menus"])], 36)], 64);
    };
  }
});